// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-stepper {
    display: inline-flex;
    align-items: stretch;
}

.number-stepper-input {
    width: 80px;
    padding: 4px 8px;
    border: 1px solid #888;
    border-right: none;
    box-sizing: border-box;
    text-align: right;
    height: fit-content;
    align-self: center;
}

.number-stepper-buttons {
    display: flex;
    gap: 0.25rem;
    margin-left: 6px;
    justify-content: center;
}

.number-stepper-buttons-row {
    flex-direction: row;
    align-items: center;
}

.number-stepper-buttons-column {
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.number-stepper-button {
    height: 24px;
    width: 24px;
    cursor: pointer;
    color: var(--color-component-foreground);
    padding: unset;
    border-radius: 50%;
    background-color: var(--color-component-background);
}

    .number-stepper-button:hover:not(:disabled) {
        color: var(--color-component-hover-fore);
        background-color: var(--color-component-hover-back);        
    }

    .number-stepper-button:disabled,.number-stepper-button.disabled,
    .number-stepper-input:disabled {
        color: var(--color-disabled-fore);
        background-color:var(--color-disabled-back);
        cursor: default;
        border-color: var(--color-disabled-fore);
    }

        .number-stepper-button:disabled .number-stepper-inner {
            border-color: var(--color-component-hover-fore);
        }

.number-stepper-inner {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    font-size: 16pt;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/css/NumberStepper.css"],"names":[],"mappings":"AAEA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,wCAAwC;IACxC,cAAc;IACd,kBAAkB;IAClB,mDAAmD;AACvD;;IAEI;QACI,wCAAwC;QACxC,mDAAmD;IACvD;;IAEA;;QAEI,iCAAiC;QACjC,2CAA2C;QAC3C,eAAe;QACf,wCAAwC;IAC5C;;QAEI;YACI,+CAA+C;QACnD;;AAER;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":["@import '../../css/App.css';\r\n\r\n.number-stepper {\r\n    display: inline-flex;\r\n    align-items: stretch;\r\n}\r\n\r\n.number-stepper-input {\r\n    width: 80px;\r\n    padding: 4px 8px;\r\n    border: 1px solid #888;\r\n    border-right: none;\r\n    box-sizing: border-box;\r\n    text-align: right;\r\n    height: fit-content;\r\n    align-self: center;\r\n}\r\n\r\n.number-stepper-buttons {\r\n    display: flex;\r\n    gap: 0.25rem;\r\n    margin-left: 6px;\r\n    justify-content: center;\r\n}\r\n\r\n.number-stepper-buttons-row {\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n\r\n.number-stepper-buttons-column {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.number-stepper-button {\r\n    height: 24px;\r\n    width: 24px;\r\n    cursor: pointer;\r\n    color: var(--color-component-foreground);\r\n    padding: unset;\r\n    border-radius: 50%;\r\n    background-color: var(--color-component-background);\r\n}\r\n\r\n    .number-stepper-button:hover:not(:disabled) {\r\n        color: var(--color-component-hover-fore);\r\n        background-color: var(--color-component-hover-back);        \r\n    }\r\n\r\n    .number-stepper-button:disabled,.number-stepper-button.disabled,\r\n    .number-stepper-input:disabled {\r\n        color: var(--color-disabled-fore);\r\n        background-color:var(--color-disabled-back);\r\n        cursor: default;\r\n        border-color: var(--color-disabled-fore);\r\n    }\r\n\r\n        .number-stepper-button:disabled .number-stepper-inner {\r\n            border-color: var(--color-component-hover-fore);\r\n        }\r\n\r\n.number-stepper-inner {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-content: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 16pt;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
